<details class="excel-import-excluded mb-3">
  <summary class="fw-bold">{{ title() }} ({{ entries().length }})</summary>
  <div class="table-responsive mt-2">
    <table class="table table-sm align-middle">
      <caption class="visually-hidden">
        {{
          title()
        }}
      </caption>
      <thead>
        <tr>
          <th scope="col">{{ texts().source }}</th>
          <th scope="col">{{ texts().date }}</th>
          <th scope="col">{{ texts().label }}</th>
          <th scope="col" class="text-end">{{ texts().amount }}</th>
          <th scope="col">{{ texts().reason }}</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of entries(); track $index) {
          <tr>
            <td class="text-nowrap">{{ entry.source }}</td>
            <td class="text-nowrap">{{ entry.date ?? '–' }}</td>
            <td>{{ entry.label ?? '–' }}</td>
            <td class="text-end text-nowrap">
              {{ entry.amount | number: '1.0-0' : 'sv' }}
            </td>
            <td>{{ texts().reasonLabels[entry.reason] }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</details>
